(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  /*
   * Extend mega-menu trigger zone for bottom-to-top cursor approach.
   * The overflow-list shadow DOM's overflow-y:hidden clips the <li>::after
   * pointer zone, so we synthesise pointerenter when the cursor dips into
   * the gap just below the nav header (within EXTEND_PX pixels).
   */
  (function () {
    var EXTEND_PX = 28;
    var lastItem = null;

    function onMove(event) {
      var header = document.getElementById('header-component');
      if (!header) return;

      var hBottom = header.getBoundingClientRect().bottom;
      var clientX = event.clientX;
      var clientY = event.clientY;

      if (clientY <= hBottom || clientY > hBottom + EXTEND_PX) {
        lastItem = null;
        return;
      }

      var items = document.querySelectorAll(
        '.menu-list__list-item:not([slot="overflow"]):not([aria-hidden="true"])'
      );
      var found = null;
      for (var i = 0; i < items.length; i++) {
        var r = items[i].getBoundingClientRect();
        if (clientX >= r.left && clientX <= r.right) {
          found = items[i];
          break;
        }
      }

      if (!found || found === lastItem) return;
      lastItem = found;
      found.dispatchEvent(
        new PointerEvent('pointerenter', {
          bubbles: false,
          cancelable: false,
          clientX: clientX,
          clientY: clientY
        })
      );
    }

    document.addEventListener('pointermove', onMove, { passive: true });
  })();

  /**
   * Timesact pre-order button text guard.
   * Race condition: Shopify's variant-change JS sometimes resets the button
   * text to "Add to Cart" after Timesact already wrote "Pre-Order". The class
   * and bg colour stay correct — only the label reverts.
   *
   * Fix: body-level MutationObserver so we survive any DOM re-render.
   * characterDataOldValue lets us recover Timesact's text even when both
   * Timesact and Shopify fire in the same microtask batch (so the button
   * already shows the wrong text by the time our callback runs).
   * TreeWalker finds the live text node without relying on Timesact's
   * inner-HTML structure.
   */
  (function () {
    var savedLabel = null;

    function isDefault(t) {
      return /^(add to cart|sold out|unavailable)$/i.test((t || '').trim());
    }

    function firstTextNode(btn) {
      var walker = document.createTreeWalker(btn, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) {
        var n = walker.currentNode;
        if (n.parentElement && n.parentElement.closest('.add-to-cart__added')) continue;
        if (n.textContent.trim()) return n;
      }
      return null;
    }

    function check(btn) {
      if (!btn || !btn.classList.contains('timesact-button')) return;
      var node = firstTextNode(btn);
      if (!node) return;
      var t = node.textContent.trim();
      if (t && !isDefault(t)) {
        savedLabel = t;
      } else if (savedLabel && isDefault(t)) {
        node.textContent = savedLabel;
      }
    }

    new MutationObserver(function (mutations) {
      // First pass: recover Timesact's label from characterData oldValue.
      // This handles the batch case where Timesact fires then Shopify fires
      // before our callback runs, leaving only the wrong text visible.
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'characterData' && m.oldValue) {
          var old = m.oldValue.trim();
          if (old && !isDefault(old) && m.target.parentElement) {
            var b = m.target.parentElement.closest('button[name="add"]');
            if (b) savedLabel = old;
          }
        }
      }
      // Second pass: fix the button's current visible text if needed.
      for (var j = 0; j < mutations.length; j++) {
        var tgt = mutations[j].target;
        var el = tgt.nodeType === 1 ? tgt : tgt.parentElement;
        if (!el) continue;
        var btn = el.closest('button[name="add"]');
        if (btn) { check(btn); break; }
      }
    }).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
      characterDataOldValue: true,
      attributes: true,
      attributeFilter: ['class']
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
